export default "__VITE_ASSET__pcVp88c3__"